import React from "react";
import { TextField, IconButton, Grid, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";

const Input = ({
  half,
  handleChange,
  label,
  name,
  type,
  handleShowPassword,
  autoFocus,
  // style, // we ignore external style so design stays consistent
  placeholder,
}) => (
  <Grid item xs={12} sm={half ? 6 : 12}>
    <TextField
      name={name}
      onChange={handleChange}
      variant="outlined"
      autoFocus={autoFocus}
      required
      fullWidth
      label={label}
      type={type}
      placeholder={placeholder}
      autoComplete={name === "password" ? "current-password" : "username"}
      InputProps={
        name === "password"
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleShowPassword}
                    edge="end"
                    aria-label={
                      type === "password" ? "Show password" : "Hide password"
                    }
                  >
                    {type === "password" ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }
          : {
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }
      }
      sx={{
        // wrapper (like .cbx-input)
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          background: "rgba(15, 23, 42, 0.98)", // same as .cbx-input
          fontSize: "0.85rem",
          color: "#f8fafc",
        },
        // border (like cbx border)
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(148, 163, 184, 0.4)",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(148, 163, 184, 0.7)",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#3b82f6",
            boxShadow: "0 0 0 2px rgba(59, 130, 246, 0.25)",
          },
        // input padding & placeholder
        "& .MuiInputBase-input": {
          padding: "10px 12px",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#94a3b8",
          opacity: 1,
        },
        // label color (if you ever use it)
        "& .MuiInputLabel-root": {
          color: "#94a3b8",
          fontSize: "0.8rem",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#3b82f6",
        },
        // icons color
        "& .MuiSvgIcon-root": {
          color: "#94a3b8",
        },
      }}
    />
  </Grid>
);

export default Input;
